import React from 'react';
import {Car} from "lucide-react";
import MechanicEngine from "../images/MechanicEngine.jpg";
import MechanicDiagnostics from "../images/MechanicDiagnostics.jpg";
import MechanicParts from "../images/MechanicParts.jpg";
import MechanicBrake from "../images/MechanicBrake.jpg";
import MechanicWheel from "../images/MechanicWheel.jpg";

const services = [
    {
        title: "Engine Repair",
        image: MechanicEngine
    },
    {
        title: "Parts Replacement",
        image: MechanicParts
    },
    {
        title: "Vehicle Diagnostics",
        image: MechanicDiagnostics
    },
    {
        title: "Hands-On Repair",
        image: MechanicBrake
    },
    {
        title: "Undercarriage Service",
        image: MechanicWheel
    },
    {
        title: "Vehicle Service",
        image: "/images/Mechanic.jpg"
    }
];
const additionalServices = [
    "Radiator replacement",
    "Water pumps",
    "Alternators",
    "Power steering pumps",
    "Fuel pumps",
    "Tune ups",
    "Suspension",
    "Steering components",
    "AC system checks and replacements",
    "Brakes",
    "Scantool diagnostics",
    "Brake Caliper Repair",
    "Brake Fluid Flush",
    "Alternator Replacement",
    "Timing Bel Replacement",
    "Spark Plug Replacement",
    "Ignition Coil Replacement",
    "Brake Pad Replacement",
    "Suspension Repair",
    "Power Steering Pump Replacement",
    "Wheel Bearing Replacement",
];

export const Menu = () => {
    return (
        <section className='services-section' id='services'>
            <div className='section-content'>
                <div className='services-header'>
                    <h2 className='section-title'>Our Services</h2>
                    <p className='services-subtitle'>Discover what we can do for you. We Do It All.</p>
                </div>
                <div className='services-list-panel'>
                    <ul className='services-list-grid'>
                        {additionalServices.map((service) => (
                            <li key={service} className='services-list-item'>
                                <span className='services-list-badge' aria-hidden='true'>
                                    <Car/>
                                </span>
                                <span>{service}</span>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className='services-grid'>
                    {services.map((service) => (
                        <article
                            key={service.title}
                            className='service-card'
                            aria-label={service.title}
                            style={{backgroundImage: `url(${service.image})`}}
                        >
                            {service.overlay !== false && <div className='service-card-overlay'/>}
                        </article>
                    ))}
                </div>
            </div>
        </section>
    )
}
